import React from 'react';
import CreateNewFolder from '@material-ui/icons/CreateNewFolder';
import Delete from '@material-ui/icons/Delete';
import Server from '../../../functions/server';
import Loading from '../../loadings';
import $ from "jquery";
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import { Input } from 'semantic-ui-react';

class Multifile extends React.Component {

  state = {
    open: false,
    fullWidth: true,
    maxWidth: 'sm',
    maxWidth: 'xs',
    files: []
  }

  getFiles() {
    let context = this;
    let id = context.props.id;
    let invoiceno = context.props.invoiceno;
    context.setState({ open1: false, open: false })
    $.ajax({
      type: 'POST',
      data: { 'id': id, 'invoiceno': invoiceno },
      url: Server()+'machinesales/getfiles.php',
      success: function(data)
      {
        console.log(data);
        context.setState({ load: false })
        try {
          data = JSON.parse(data);
          console.log(data);
          context.setState({ files: data, open: true })
        } catch (e) {
          alert('Error!!!')
        }
      },
      error: function(e)
      {
        console.log(e);
        alert('Try again!!')
        context.setState({
          load: false
        });
      }
    });
  }

  submit() {
    if (this.props.machinesalesedit == 'none') {
      alert('Access is Denied!!!');
      return;
    }
    if (this.state.fileName == '' || this.state.fileName == null || this.state.fileName == undefined) {
      alert('Enter File name');
      return;
    }
    let context = this;
    let file = this.state.loadedfile;
    var formData = new FormData();
    formData.append('id', context.props.id);
    formData.append('fileName', context.state.fileName);
    formData.append('file', file);
    this.setState({ loading: true, message: 'Uploading File!!!!' })
    $.ajax({
      type: 'POST',
      processData: false,
      contentType: false,
      data: formData,
      url: Server() + 'machinesales/uploadfile.php',
      success: function(data)
      {
        console.log(data);
        if (data == 1) {
          alert('Pdf Uploaded');
          context.getFiles();
          context.setState({ loading: false })
        }
        else {
          alert('PDF not upload');
          context.setState({ loading: false })
        }
      },
      error: function(err)
      {
        context.setState({
          error: "Try again",
          loading: false
        });
      }
    });
  }

  uploadpdf(file) {
    this.setState({
      loadedfile: file,
      open1: true
    })
  }

  changeHandle = name => event => {
    this.setState({
      [name]: event.target.value,
    });
  };

  deleteFile(id, source) {
    if (this.props.machinesalesedit == 'none') {
      alert('Access is Denied!!!');
      return;
    }
    let context = this;
    $.ajax({
      type: 'POST',
      data: { 'id': id, 'name': source },
      url: Server() + 'machinesales/deletefile.php',
      success: function(data)
      {
        console.log(data);
        if (data == 1) {
          context.getFiles();
        }
        else {
          alert('Error!!!');
        }
      },
      error: function(err)
      {
        context.setState({
          error: "Try again",
        });
      }
    });
  }

  openLink(file) {
    window.open(file);
  }

  render() {
    let  i = 0;
    return (
      <div>
        <Loading load={this.state.loading} message={this.state.message} />
        <div style={{ display: 'flex' }}>
          <CreateNewFolder style={{color: '#C49932', cursor: 'pointer'}}
            onClick={this.getFiles.bind(this)} />
        </div>
        <Dialog fullWidth={this.state.fullWidth} maxWidth={this.state.maxWidth}
          open={this.state.open}   onClose={ () => { this.setState({ open: false }) }}
          aria-labelledby="max-width-dialog-title">
          <DialogTitle id="max-width-dialog-title">Files</DialogTitle>
          <DialogContent style={{paddingLeft: '4%'}}>
            <DialogContentText>
              { this.state.files.map((x) => {
                  ++i;
                  return (
                    <div style={{padding: '1%', cursor: 'pointer', display: 'flex'}}>
                      <u style={{color: '#6CA1EE'}} onClick={this.openLink.bind(this, x.files)}>
                        {i+".  "+x.filename}
                      </u>
                      <p style={{paddingLeft: '2%'}}>
                        <Delete onClick={this.deleteFile.bind(this, x.id, x.files)} />
                      </p>
                    </div>
                  )
                })
              }
              Upload File<br/>
              <input type="file" accept="application/pdf" name="fileToUpload" id="fileToUpload" onChange={(e) => { this.uploadpdf(e.target.files[0]) }}/>
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={ () => { this.setState({ open: false }) }} color="primary">
              Close
            </Button>
          </DialogActions>
        </Dialog>

        <Dialog fullWidth={this.state.fullWidth} maxWidth={this.state.maxWidth1}
          open={this.state.open1}   onClose={ () => { this.setState({ open1: false }) }}
          aria-labelledby="max-width-dialog-title">
          <DialogTitle id="max-width-dialog-title">Files</DialogTitle>
          <DialogContent style={{paddingLeft: '4%'}}>
            <DialogContentText>
              File name
              <Input value={this.state.fileName} onChange={this.changeHandle('fileName')} />
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={this.submit.bind(this)} color="primary">
              Submit
            </Button>
            <Button onClick={ () => { this.setState({ open1: false }) }} color="primary">
              Close
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    );
  }
}

export default Multifile;
